export class FilterQueryParameters {
  levels = "";
  ctry_id = "";
  state_id = "";
  city_id = "";
  site_id = "";
  bl_id = "";
  fl_id = "";
  rm_arrange_type_id = "";
  emails: string[] = [];

  constructor(initializer?: any) {
    if (!initializer) return;

    if (initializer.levels) this.levels = initializer.levels;
    if (initializer.ctry_id) this.ctry_id = initializer.ctry_id;
    if (initializer.state_id) this.state_id = initializer.state_id;
    if (initializer.city_id) this.city_id = initializer.city_id;
    if (initializer.site_id) this.site_id = initializer.site_id;
    if (initializer.bl_id) this.bl_id = initializer.bl_id;
    if (initializer.fl_id) this.fl_id = initializer.fl_id;
    if (initializer.rm_arrange_type_id) this.rm_arrange_type_id = initializer.rm_arrange_type_id;
    if (initializer.emails) this.emails = initializer.emails;
  }

  toUrlParams(): string {
    let params = `?levels=${this.levels}`;
    if (this.ctry_id != "") {
      params += `&ctry_id=${this.ctry_id}`;
    }
    if (this.state_id != "") {
      params += `&state_id=${this.state_id}`;
    }
    if (this.city_id != "") {
      params += `&city_id=${this.city_id}`;
    }
    if (this.site_id != "") {
      params += `&site_id=${this.site_id}`;
    }
    if (this.bl_id != "") {
      params += `&bl_id=${this.bl_id}`;
    }
    if (this.fl_id != "") {
      params += `&fl_id=${this.fl_id}`;
    }
    if (this.rm_arrange_type_id != "") {
      params += `&rm_arrange_type_id=${this.rm_arrange_type_id}`;
    }
    if (this.emails != null && this.emails.length > 0) {
      params += `&emails=${this.emails}`;
    }
    return params;
  }
}
